// extracted by mini-css-extract-plugin
export default {"modal":"confirm-import-modal_modal__fSGDh","lowercase":"confirm-import-modal_lowercase__DGqJZ","btns":"confirm-import-modal_btns__2Fi7u","btn":"confirm-import-modal_btn__k6My5"};